<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'SendToBackImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'move-to-back',
      title: 'Send to back',
      showLocal: true,

      hotkey: 'meta+shift+down',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas.getActiveObject()) {
        this.showLocal = true;
      } else {
        this.showLocal = false;
      }
    },
    action() {
      if (this.canvas.getActiveObject()) {
        this.canvas.sendToBack(this.canvas.getActiveObject());
        this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
      }
    },
  },
};
</script>
